export default __webpack_public_path__ + "assets/images/8dbc2b99058dbf3d621e2435e583cb16.png";